import { MapPinned } from "lucide-react";
import { useState } from "react";
import CampusMapExperience from "../components/campus/CampusMapExperience";
import CampusMapTabs from "../components/campus/CampusMapTabs";

const campuses = {
  performance: {
    label: "Performance World",
    title: "PERFORMANCE WORLD CAMPUS",
    imageUrl:
      "https://customer-assets-jt897jd0.emergentagent.net/job_innovation-ecosystem-4/"
      + "artifacts/q6r8cebi_Gameday%20Performance%20Campus.png",
    imageAlt:
      "GAMEDAY Performance Center proposed campus board with numbered facility callouts.",
    intro:
      "Explore the proposed relationship between training, recovery, science, operations, "
      + "and innovation spaces.",
    facilities: [
      {
        id: "dome",
        marker: "01",
        name: "Performance Dome",
        type: "Training",
        x: 50,
        y: 37,
        detail:
          "Environmental training, multi-sport preparation, and immersive performance scenarios.",
      },
      {
        id: "science",
        marker: "02",
        name: "Sports Science Center",
        type: "Research",
        x: 39,
        y: 32,
        detail:
          "Biomechanics, motion analysis, diagnostics, testing, and research collaboration.",
      },
      {
        id: "recovery",
        marker: "03",
        name: "Recovery Institute",
        type: "Recovery",
        x: 41,
        y: 55,
        detail:
          "Future recovery programming, resilience education, and licensed healthcare "
          + "partnerships.",
      },
      {
        id: "operations",
        marker: "04",
        name: "Team Operations Village",
        type: "Operations",
        x: 58,
        y: 57,
        detail:
          "Locker rooms, strategy suites, nutrition spaces, and team media environments.",
      },
      {
        id: "innovation",
        marker: "05",
        name: "Innovation Park",
        type: "Innovation",
        x: 24,
        y: 54,
        detail:
          "A collaboration zone for demonstrations, university programs, research, and investor "
          + "showcases.",
      },
    ],
  },
  military: {
    label: "Military Performance Center",
    title: "MILITARY PERFORMANCE CENTER",
    imageUrl:
      "https://customer-assets-jt897jd0.emergentagent.net/job_innovation-ecosystem-4/"
      + "artifacts/yev5mtla_Military%20Purpose%20Campus.png",
    imageAlt:
      "GAMEDAY Military Performance Center proposed campus map with numbered facility callouts.",
    intro:
      "Explore the proposed readiness campus connecting simulation, environmental preparation, "
      + "recovery, and review spaces.",
    facilities: [
      {
        id: "battlesphere",
        marker: "01",
        name: "The BattleSphere",
        type: "Simulation",
        x: 43,
        y: 34,
        detail:
          "A proposed immersive simulation dome for adaptable training environments and "
          + "after-action review.",
      },
      {
        id: "environment",
        marker: "02",
        name: "Environmental Readiness Dome",
        type: "Readiness",
        x: 29,
        y: 33,
        detail:
          "Potential heat, cold, humidity, terrain, endurance, and equipment-testing environments.",
      },
      {
        id: "human",
        marker: "03",
        name: "Tactical Human Performance",
        type: "Performance",
        x: 34,
        y: 53,
        detail:
          "Strength, mobility, load carriage, resilience, movement, nutrition, and "
          + "fatigue-monitoring concepts.",
      },
      {
        id: "command",
        marker: "04",
        name: "Command & Control",
        type: "Operations",
        x: 56,
        y: 53,
        detail:
          "Mission-planning rooms, exercise control, observer stations, and after-action theaters.",
      },
      {
        id: "recovery",
        marker: "05",
        name: "Recovery & Resilience",
        type: "Recovery",
        x: 21,
        y: 55,
        detail:
          "Future physical recovery, sleep-performance education, nutrition, and resilience "
          + "support.",
      },
    ],
  },
};

export default function CampusMapPage() {
  const [campusKey, setCampusKey] = useState("performance");
  const campus = campuses[campusKey];
  const [selectedId, setSelectedId] = useState(campus.facilities[0].id);
  const changeCampus = (key) => {
    setCampusKey(key);
    setSelectedId(campuses[key].facilities[0].id);
  };

  return (
    <main className="campus-map-page" data-testid="campus-map-page">
      <section className="campus-map-header">
        <MapPinned aria-hidden="true" size={33} />
        <span className="eyebrow">Proposed campus explorer</span>
        <h1>
          EXPLORE THE <em>ECOSYSTEM.</em>
        </h1>
        <p>
          Select a numbered facility marker to understand its intended role. All locations,
          capabilities, and layouts remain conceptual and subject to change.
        </p>
      </section>

      <CampusMapTabs campuses={campuses} campusKey={campusKey} onChange={changeCampus} />
      <CampusMapExperience
        campus={campus}
        campusKey={campusKey}
        onSelect={setSelectedId}
        selectedId={selectedId}
      />
    </main>
  );
}